import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { DpsVcService } from './dps-dashboard-vc.service';
import { VcaAlertsService } from '../../../../../common/vca-alerts/vca-alerts.service';
import { Subscription } from 'rxjs/Rx';
import { RefreshSharedService } from '../../../../refresh-shared-service';

@Component({
    selector: 'dps-dashboard-vc',
    styles: [require('./dps-dashboard-vc.scss')],
    template: require('./dps-dashboard-vc.html')
})
export default class DPSDashboardVC {

    private dpsVcList: any;
    private chartOptions: any;
    private dpsVcData = [];
    private deletedVmMap = {};
    private loaded: boolean = false;
    private rsService: RefreshSharedService;
    private refreshSubscription: Subscription;
    private currentClassName: string = '';

    constructor(private translate: TranslateService,
                private service: DpsVcService,
                private alert: VcaAlertsService,
                private rss: RefreshSharedService) {
        translate.use(GlobalVariables.LOCALE);
        this.rsService = rss;
        this.currentClassName = 'DPSDashboardVC';
    }

  ngOnInit() {
    this.refreshSubscription = this.rsService.getRefreshParam()
    .subscribe (
    item => {
        this.handleEmittedValues(item);
    });

    this.chartOptions = {
            scaleShowVerticalLines: false,
            responsive: true,
            legend: {
                display: false,
                position: 'top'
            },
            cutoutPercentage: 75
        };
        this.getVcData();
    }

   handleEmittedValues(item) {
    if (item.loadedComponent === this.currentClassName) {
        this.getVcData();
    }
  }

    getVcData() {
        this.loaded = false;
        Promise.resolve(this.service.getDeletedVMList())
            .then((data:any) => {
                let deletedVmList = data;
                for (let i = 0; i < deletedVmList.length; i += 1) {
                        let vcId = deletedVmList[i].vcenter_instanceId;
                        let vmStorage = deletedVmList[i].statistics.storageConsumed;
                        if (this.deletedVmMap[vcId]) {
                            let vmStats = this.deletedVmMap[vcId];
                            let vmCount = vmStats.deletedVmCount;
                            let vmStorageConsumed = vmStats.storageConsumed;
                            vmCount += 1;
                            vmStorageConsumed += vmStorage;
                            this.deletedVmMap[vcId] = {
                                deletedVmCount: vmCount,
                                storageConsumed: vmStorageConsumed
                            };
                        } else {
                            this.deletedVmMap[vcId] = {
                                deletedVmCount: 1,
                                storageConsumed: vmStorage
                            };
                        }
                    }
                    this.getDpsVcList();
                }
            );
    }

    getDpsVcList() {
        this.service.getDpsVcList()
            .subscribe(
                data => {
                    this.dpsVcList = data;
                    this.dpsVcData.length = 0;

                    for (let i = 0; i < this.dpsVcList.length; i += 1) {
                        let dpsVc: any;
                        let vmPieChartData: any;
                        let vmCounts: any;
                        let storageChartData: any;
                        let storageConsumedData: any;

                        let vcName = this.dpsVcList[i].name;
                        let vcId = this.dpsVcList[i].entity_id;
                        let protectedVMCount = 0;
                        let totalVMCount = 0;
                        let storageConsumed = 0;

                        if (this.dpsVcList[i].statistics) {
                            if (this.dpsVcList[i].statistics.protectedVMCount) {
                                protectedVMCount = this.dpsVcList[i].statistics.protectedVMCount;
                            }
                            if (this.dpsVcList[i].statistics.totalVMCount) {
                                totalVMCount = this.dpsVcList[i].statistics.totalVMCount;
                            }
                            if (this.dpsVcList[i].statistics.storageConsumed) {
                                storageConsumed = this.dpsVcList[i].statistics.storageConsumed;
                            }
                        }

                        vmCounts = {
                            data: [protectedVMCount, totalVMCount - protectedVMCount],
                            backgroundColor: [(totalVMCount - protectedVMCount) > 0 ?
                                '#007CBB' : '#D0011B']
                        };

                        vmPieChartData = {
                            labels: [this.translate.instant('vcDpsModule.dashboard.policyEnabled'),
                                this.translate.instant('vcDpsModule.dashboard.policyNotEnabled')],
                            datasets: [vmCounts]
                        };

                        let storageConsumedString = (storageConsumed / 1024).toFixed(2);

                        storageConsumedData = {
                            data: [storageConsumedString, 0],
                            backgroundColor: ['#E6E6E6']
                        };

                        storageChartData = {
                            labels: [this.translate.instant('vcDpsModule.dashboard.storageConsumed'),
                                this.translate.instant('vcDpsModule.dashboard.storageFree')],
                            datasets: [storageConsumedData]
                        };


                        let deletedVmCount = 0;
                        let deletedStorageConsumedString = '0';

                        if (this.deletedVmMap && this.deletedVmMap[vcId]) {
                            deletedVmCount = this.deletedVmMap[vcId].deletedVmCount;
                            let deletedStorageConsumed = this.deletedVmMap[vcId].storageConsumed;
                            deletedStorageConsumedString =
                                (deletedStorageConsumed / 1024).toFixed(2);
                        }


                        dpsVc = {
                            vcentername: vcName,
                            totalVmCount: totalVMCount,
                            vmPieChartData: vmPieChartData,
                            vmPieChartOption: this.chartOptions,
                            storageChartData: storageChartData,
                            storageChartOption: this.chartOptions,
                            deletedVmCount: deletedVmCount,
                            deletedVmStorage: deletedStorageConsumedString
                        };

                        this.dpsVcData.push(dpsVc);
                    }
                    this.loaded = true;
                },
                error => {
                    this.alert.danger(['Failed to retrieve VCenters', error], 'vcenter-grid');
                    this.loaded = true;
                }
            );
    }

  ngOnDestroy() {
    if (this.refreshSubscription) {
        this.refreshSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/dashboard/dps-dashboard-vc.component.ts